module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Legg memolife","paragraph":"til startsiden","buttonText":"Legg"},"en":{"title":"Add Memolife","paragraph":"to Home Screen","buttonText":"Add"}}')
  delete Component.options._Ctor
}
